import { Alert } from "@vjal/ui";

type ErrorFallbackProps = {
  title?: string;
  message?: string;
  reference?: string | null;
};

export function ErrorFallback({
  title = "Something went wrong",
  message = "Refresh and try again. If it repeats, capture the error reference and route it through the implementation ledger.",
  reference
}: ErrorFallbackProps) {
  return (
    <Alert variant="error">
      <strong>{title}.</strong> {message}
      {reference ? <> Error reference: {reference}.</> : null}
    </Alert>
  );
}
